import { FuseChipSelect } from "@fuse";
import _ from "@lodash";
import { FormControl, FormControlLabel, MenuItem, Paper, Switch, Tab, Tabs, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import TagFormulario from "app/Core/Components/TagFormulario/TagFormulario";
import WebexAgendar from "app/Core/Components/Webex/WebexAgendar";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import EmpresaPacienteApp from "app/ERP/EmpresaPaciente/EmpresaPacienteApp";
import EmpresaPessoaApp from "app/ERP/EmpresaPessoa/EmpresaPessoaApp";
import EmpresaProdutoToggleButton from "app/ERP/EmpresaProduto/EmpresaProdutoToggleButton";
import EmpresaTarefaApp from "app/ERP/EmpresaTarefa/EmpresaTarefaApp";
import ArquivoApp from "app/GED/Arquivo/ArquivoApp";
import Planos from "app/Planos/index.json";
import TarefaApontamentoPedidoEmAberto from "app/Workflow/TarefaApontamento/TarefaApontamentoPedidoEmAberto";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import { Anotacao, Contato, DataHora, Produto, Responsavel, VincularOportunidade } from "../Components";
const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
   root: {
      color: theme.palette.text.primary,
   },
   formControl: {
      margin: "0px 0",
      width: "100%",
      "&:last-child": {
         marginBottom: 0,
      },
   },
   group: {},
   formGroupTitle: {
      position: "absolute",
      top: -10,
      left: 8,
      fontWeight: 600,
      padding: "0 4px",
      backgroundColor: theme.palette.type === "dark" ? "#424242" : "#FFF",
      fontSize: "12px",
   },
   formGroup: {
      position: "relative",
      //maxHeight: '58px',
      border: "1px solid " + theme.palette.divider,
      borderRadius: 2,
   },
   spanlabel: {
      top: 9,
      left: 15,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      paddingRight: 5,
      paddingLeft: 5,
      fontSize: 12.5,
      fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
      color: theme.palette.text.secondary,
      maxWidth: 140,
   },
   divPaperHorario: {
      height: 400,
      maxWidth: "100%",
   },
   divContatos: {
      backgroundColor: theme.palette.background.paper,
   },
   selected: {
      backgroundColor: theme.palette.type === "dark" ? "rgb(255, 255, 255, .1)" : "rgb(0, 0, 0, .08)",
   },
   select: {
      "& .fuse-chip-select__indicators": {
         display: "none",
      },
      "& div:before, div:after": {
         "border-bottom": "none !important",
      },
   },
   chip: {
      height: "auto",
      minHeight: 32,
      margin: "4px 4px 4px 0",
      "& span": {
         whiteSpace: "normal",
      },
   },
   toolbar: {
      background: theme.palette.type === "dark" ? "#303030" : "#E6E6E6",
      borderRadius: "4px 4px 0 0",
   },
});

const STATUS = [
   // ALTERAR LABEL MAS NUNCA ALTERAR ID (EXISTEM FILTRO NO BANCO)
   { "id": 1, "label": "Agendado", "icon": "calendar", "cor": "", "iniciarprocesso": false, "cancelarprocesso": true, "disabled": [9, 10, 11] },
   { "id": 2, "label": "Disponível", "icon": "ampulheta", "cor": "text-blue", "iniciarprocesso": true, "cancelarprocesso": false, "disabled": [9, 10, 11] },
   { "id": 3, "label": "Check in", "icon": "run", "cor": "", "iniciarprocesso": true, "cancelarprocesso": false, "disabled": [9, 10, 11] },
   { "id": 8, "label": "Triagem", "icon": "filtro", "cor": "", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [9, 10, 11] },
   { "id": 4, "label": "Em atendimento", "icon": "retrato", "cor": "", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
   { "id": 11, "label": "Checkout", "icon": "exit", "cor": "", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
   { "id": 9, "label": "Atendido", "icon": "done", "cor": "", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
   { "id": 10, "label": "Finalizado", "icon": "done_all", "cor": "text-green", "iniciarprocesso": false, "cancelarprocesso": false, "disabled": [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12] },
   { "id": 5, "label": "Cancelado pelo profissional", "icon": "calendar_minus", "cor": "text-red", "iniciarprocesso": false, "cancelarprocesso": true, "disabled": [9, 10, 11] },
   { "id": 6, "label": "Cancelado pelo paciente", "icon": "calendar_close", "cor": "text-red", "iniciarprocesso": false, "cancelarprocesso": true, "disabled": [9, 10, 11] },
   { "id": 7, "label": "Não compareceu", "icon": "person_off", "cor": "text-red", "iniciarprocesso": false, "cancelarprocesso": true, "disabled": [9, 10, 11] },
   { "id": 12, "label": "Reagendado", "icon": "calendar", "cor": "text-red", "iniciarprocesso": false, "cancelarprocesso": true, "disabled": [9, 10, 11] },
];

class Default extends XAPPComponent {

   state = {
      showContent: 0,
      filtroPessoa: "",
      showHorarios: false,
   };

   componentDidMount() {
      this.setState(_.set({ ...this.state }, "showContent", this.checkExistsContent(this.props.openContent)));
   }

   componentDidUpdate() {
      if (!_.isNull(document.getElementById("ContentDivHorario")) && !_.isNull(document.getElementById("Content"))) {
         document.getElementById("ContentDivHorario").style.height = document.getElementById("Content").parentNode.offsetHeight - 120 + "px";
      }


   }

   checkExistsContent = _AContent => {
      const AContents = {
         "agendamento": 0,
         "anotacoes": 1,
         "empresatarefa": 2,
      };

      if (!_.isUndefined(AContents[_AContent])) {
         return AContents[_AContent];
      }
      return 0;
   };

   isMobileCliente = () => {
      const { form } = this.props;

      return (
         !_.isNull(md.mobile()) ||
         !_.isNull(md.tablet()) ||
         (!_.isUndefined(form.clientesLookup) && !_.isNull(form.clientesLookup) && form.clientesLookup.length > 1)
      );
   };

   getPessoaFiltro = () => {
      const { form } = this.props;
      let AResponse = [];
      if (this.state.filtroPessoa.length === 0) {
         return form.clientesLookup;
      } else {
         form.clientesLookup.forEach((item) => {
            if (typeof item.nome === "string" && item.nome.toLowerCase().includes(this.state.filtroPessoa.toLowerCase())) {
               AResponse.push(item);
            }
         });
      }
      return AResponse;
   };

   showSidebar = () => {
      const { form } = this.props;
      const { showContent } = this.state;
      return (
         showContent === 0 && !_.isNull(form.responsaveis) && form.responsaveis.length > 0
         // || (!_.isUndefined(form.preatendimento.pedido) && !_.isNull(form.preatendimento.pedido) && form.preatendimento.pedido.length > 0)
      );
   };

   getLabelPaper = (_AID) => {
      switch (_AID) {
         case 0:
            return "Agendamento";
         case 1:
            return "Anotações";
         case 2:
            return "Tarefas";
         default:
            return "Agendamento";
      }
   };

   existsProcesso = () => {
      const { form } = this.props;
      return !_.isNull(form.idagendamento) && _.findIndex(form.clientesLookup, (x) => x.idtarefaprocesso !== null) !== -1;
   };

   getDadosWebex = () => {
      const { form } = this.props;
      let AResponse = Object.assign({}, form);
      let AArray = [];
      form.clientesLookup.forEach(item => {
         AArray.push(item.nome);
      });
      AResponse.titulo = "Atendimento Dr(a)." + form.responsaveisLookup[0].nome + " x " + AArray.join(", ");
      return AResponse;
   };

   render() {
      const { callback, form, handleChange, handleChangeCheck, handleLookupClientes, TagsPessoa, canScheduleWebex, showWebex, getBaseFiltro, handleProdutos, saveAgendamentoPessoa, canBeSubmitted, getHorarioAgendadoAll, TagsAgendamento, user, EmpresaLocais, get, getProdutos, getResponsaveis, handleLookupFontePagadora, handleChangeHorarios, checkHorarioDisponivel, handleResponsaveis, handleChangeAnotacoes, classes, xappRouteParams, HorarioAgendado, handleChangeData, save, } = this.props;

      let AValorTotal = 0;
      let ADuracaoTotal = 0;
      if (!_.isUndefined(form.preatendimento.pedido) && !_.isNull(form.preatendimento.pedido)) {
         form.preatendimento.pedido.forEach((item) => {
            AValorTotal += Number.parseFloat(item.valor);
            let tmp = ["00", "00"];
            if (!_.isUndefined(item.duracao) && !_.isNull(item.duracao) && item.duracao.length > 0 && item.duracao.includes(":")) {
               tmp = item.duracao.split(":");
            }
            if (tmp.length > 0) {
               ADuracaoTotal += Number(tmp[0]) * 60 + Number(tmp[1]);
            }
         });
      }
      let ATmp = (ADuracaoTotal / 60).toFixed(2).split(".")[1];
      let ATempoString = Helpers.pad(Math.trunc(ADuracaoTotal / 60)) + " hr " + Helpers.pad(Number(ATmp) * 0.6) + " min";
      let ASelecionadoString = "00 hr 00 min";
      if (!_.isNull(form.inicio) && !_.isNull(form.termino)) {
         let ASelecionado = Helpers.DateDiffMinutes(form.data + " " + form.inicio, form.data + " " + form.termino);
         ASelecionadoString = Helpers.pad(Math.trunc(ASelecionado / 60)) + " hr " + Helpers.pad(ASelecionado % 60) + " min";
      }
      return (
         <React.Fragment>
            <Tabs
               value={form.tabValue}
               onChange={(ev, n) => handleChange({ target: { name: "tabValue", value: n } })}
               indicatorColor="secondary"
               textColor="secondary"
               variant="scrollable"
               scrollButtons="off"
               classes={{ root: "h-48 w-full" }}
            >
               <Tab value={0} className="h-48 normal-case" label={"Principal"} />
               {
                  this.isMobileCliente() && <Tab value={1} className="h-48 capitalize" label={this.getDicionario("cliente", "cliente")} />
               }
               {!_.isUndefined(form.preatendimento.pedido) && !_.isNull(form.preatendimento.pedido) && form.preatendimento.pedido.length > 0 && (
                  <Tab value={2} className="h-48 normal-case" label={"Serviços"} />
               )}
               {
                  !_.isNull(form.responsaveisLookup) && form.responsaveisLookup.length > 0 && (
                     <Tab value={3} className="h-48 capitalize" label={this.getDicionario("profissional", "profissional")} />
                  )
               }
               {Helpers.checkPlano(Planos.agendamento.oportunidades, user.settings) && !_.isNull(form.idagendamento) && !_.isNull(form.clientes) &&
                  <Tab value={4} className="h-48 normal-case" label={"Oportunidade"} />
               }
               <Tab value={6} className="h-48 normal-case" label={"Pedidos em aberto"} />
               {/* {!_.isNull(form.idagendamento) &&
                  <Tab value={5} className="h-48 normal-case" label={"Arquivos"} />
               } */}
            </Tabs>
            {form.tabValue === 0 && (
               <React.Fragment>
                  <div id="Content" className={"w-full flex px-8 lg:px-16 flex-wrap lg:flex-no-wrap lg:flex-row"}>
                     <div className={"flex w-full items-start flex-col"}>
                        {!this.isMobileCliente() &&
                           !_.isUndefined(form.clientesLookup) &&
                           !_.isNull(form.clientesLookup) &&
                           form.clientesLookup.length > 0 && (
                              <div id="divContatos" className={clsx(classes.divContatos, "w-full", document.fullscreenElement && "p-12")}>
                                 {form.clientesLookup.length > 5 && (
                                    <div className="flex w-full items-center">
                                       <TextField
                                          className="w-full"
                                          id="filtroPessoa"
                                          name="filtroPessoa"
                                          value={this.state.filtroPessoa}
                                          onChange={(ev) => this.setState(_.set({ ...this.state }, "filtroPessoa", ev.target.value))}
                                          fullWidth
                                          placeholder="Filtrar"
                                          InputLabelProps={{
                                             shrink: true,
                                          }}
                                       />
                                       <XAPPButton
                                          id="buttonFullScreen"
                                          icon={!document.fullscreenElement ? "full_screen" : "exit_full_screen"}
                                          type="icon"
                                       />
                                    </div>
                                 )}
                                 <div className="flex flex-wrap w-full">
                                    {this.getPessoaFiltro().length > 0 ? (
                                       <React.Fragment>
                                          {this.getPessoaFiltro().map((item, x) => (
                                             <Contato
                                                key={x}
                                                data={item}
                                                xappRouteParams={xappRouteParams}
                                                agendamento={form}
                                                save={save}
                                                saveAgendamentoPessoa={saveAgendamentoPessoa}
                                                get={get}
                                                STATUS={STATUS}
                                                showTitle={true}
                                                TagsPessoa={TagsPessoa}
                                                handleChange={handleChange}
                                             />
                                          ))}
                                       </React.Fragment>
                                    ) : (
                                       <div className="flex w-full justify-center">
                                          <Typography className={"text-13 mb-12 whitespace-no-wrap"}>
                                             {"O filtro não localizou resultados"}
                                          </Typography>
                                       </div>
                                    )}
                                 </div>
                              </div>
                           )}

                        <Paper className={clsx(classes.divDados, "flex flex-col items-center w-full mt-8 pb-12")}>
                           <div className={clsx(classes.toolbar, "w-full flex flex-row items-start justify-start items-center")}>
                              <Typography className="ml-8" color="action">
                                 {this.getLabelPaper(this.state.showContent)}
                              </Typography>
                              <div className="flex-1" />
                              <XAPPButton
                                 tooltip={{ title: "Agendamento", placement: "top" }}
                                 type="icon"
                                 className={clsx("p-8", this.state.showContent === 0 && classes.selected)}
                                 variant="contained"
                                 color="textSecondary"
                                 onClick={() => this.setState(_.set({ ...this.state }, "showContent", 0))}
                                 iconProps={clsx(classes.textColor, "text-18")}
                                 icon={"forms"}
                              />
                              <XAPPButton
                                 tooltip={{ title: "Anotações", placement: "top" }}
                                 type="icon"
                                 className={clsx("p-8", this.state.showContent === 1 && classes.selected)}
                                 variant="contained"
                                 color="textSecondary"
                                 onClick={() => this.setState(_.set({ ...this.state }, "showContent", 1))}
                                 iconProps={clsx(classes.textColor, "text-18")}
                                 icon={"notes"}
                              />
                              {!_.isNull(form.idagendamento) && (
                                 <XAPPButton
                                    tooltip={{ title: "Tarefas", placement: "top" }}
                                    type="icon"
                                    className={clsx("p-8", this.state.showContent === 2 && classes.selected)}
                                    variant="contained"
                                    color="textSecondary"
                                    onClick={() => this.setState(_.set({ ...this.state }, "showContent", 2))}
                                    iconProps={clsx(classes.textColor, "text-18")}
                                    icon={"checklist_add"}
                                 />
                              )}
                              {canScheduleWebex() &&
                                 <WebexAgendar
                                    openAutomatic={form.preatendimento?.videoChamada}
                                    agendado={form.preatendimento.webex}
                                    xappRouteParams={xappRouteParams}
                                    dados={this.getDadosWebex()}
                                    save={(value) => {
                                       save({ ...form, preatendimento: { ...form.preatendimento, webex: value, videoChamada: false } }, xappRouteParams, "ATUALIZAR");
                                    }}
                                 />
                              }
                           </div>
                           {this.state.showContent === 0 && (
                              <React.Fragment>
                                 {showWebex() && _.isNull(form.idagendamento) &&
                                    <div className={clsx("flex w-full justify-center px-12")}>
                                       <FormControl className={"mb-4"}>
                                          <FormControlLabel
                                             className={"mx-0"}
                                             labelPlacement={"end"}
                                             control={
                                                <Switch
                                                   classes={{ switchBase: classes.switchBase }}
                                                   className=""
                                                   name={"preatendimento.videoChamada"}
                                                   type="checkbox"
                                                   checked={form.preatendimento?.videoChamada}
                                                   onChange={handleChangeCheck}
                                                />
                                             }
                                             label={<Typography color="textSecondary">{"Criar sala de video chamada"}</Typography>}
                                          />
                                       </FormControl>
                                    </div>
                                 }
                                 <div className={clsx("flex w-full items-start flex-wrap sm:flex-no-wrap px-12")}>
                                    <div
                                       className={clsx(
                                          classes.formGroup,
                                          "flex flex-row rounded-6 mt-16 py-2",
                                          !_.isNull(EmpresaLocais) ? "xs:w-full sm:w-1/2 sm:mr-8" : " w-full"
                                       )}
                                    >
                                       <Typography className={classes.formGroupTitle} color="textSecondary">
                                          {"Tags"}
                                       </Typography>
                                       <FormControl component="span" className={classes.formControl} key={"Tags_Paper"} name={"Tags_Paper"}>
                                          <TagFormulario
                                             key={"TagsAgendamento"}
                                             tags={!_.isUndefined(TagsAgendamento) && !_.isNull(TagsAgendamento) ? TagsAgendamento : []}
                                             selected={form.tags}
                                             target="tags"
                                             onChange={handleChange}
                                             readOnly={!_.isNull(form.idagendamento) && !canBeSubmitted()}
                                             xappRouteParams={xappRouteParams}
                                             refreshTags={callback}
                                             tipo={"agendamento"}
                                          />
                                       </FormControl>
                                    </div>
                                    {!_.isUndefined(EmpresaLocais) && !_.isNull(EmpresaLocais) && (
                                       <TextField
                                          className="mt-16 w-full sm:w-1/2"
                                          label="Local"
                                          id="idpessoaformulariolocal"
                                          name="idpessoaformulariolocal"
                                          value={form.idpessoaformulariolocal}
                                          onChange={handleChange}
                                          variant="outlined"
                                          fullWidth
                                          disabled={!_.isNull(form.idagendamento) && !canBeSubmitted()}
                                          placeholder="Selecione"
                                          InputLabelProps={{
                                             shrink: true,
                                          }}
                                          select
                                       >
                                          <MenuItem key={"Local_Dafault"} value={null}>
                                             {""}
                                          </MenuItem>
                                          {EmpresaLocais.map((item) => (
                                             <MenuItem key={"Local_" + item.idpessoaformulario} value={item.idpessoaformulario}>
                                                {item.nome}
                                             </MenuItem>
                                          ))}
                                       </TextField>
                                    )}
                                 </div>
                                 <div className={clsx("flex w-full flex-wrap sm:flex-no-wrap items-start px-12")}>
                                    <FuseChipSelect
                                       className="mt-16 w-full sm:w-1/2 sm:mr-8"
                                       variant="fixed"
                                       value={form.responsaveisLookup !== null ? form.responsaveisLookup : []}
                                       onChange={handleResponsaveis}
                                       placeholder=""
                                       isMulti
                                       isDisabled={!_.isNull(form.idagendamento)}
                                       isClearable={!_.isNull(form.idagendamento)}
                                       options={getResponsaveis()}
                                       noOptionsMessage={() => "Sem resultados"}
                                       classes={{
                                          valueContainer: "pl-8",
                                       }}
                                       textFieldProps={{
                                          className: "flex-no-wrap capitalize",
                                          "label": `${this.getDicionario("profissional", "profissional")} *`,
                                          InputLabelProps: {
                                             shrink: true,
                                          },
                                          classes: { root: classes.select },
                                          variant: "outlined",
                                       }}
                                    />
                                    <EmpresaPacienteApp
                                       className="mt-16 w-full sm:w-1/2"
                                       xappRouteParams={xappRouteParams}
                                       selected={form.clientesLookup !== null ? form.clientesLookup : []}
                                       label={this.getDicionario("cliente", "cliente")}
                                       id={"LookupNovoAgendamentoCliente"}
                                       onChange={handleLookupClientes}
                                       callback={() => get(form.idagendamento, xappRouteParams)}
                                       required={true}
                                       isLookup={true}
                                       multiSelect={false}
                                       readOnly={!_.isNull(form.idagendamento)}
                                    />
                                 </div>
                                 {!this.existsProcesso() && (
                                    <div className={clsx("flex w-full flex-wrap sm:flex-no-wrap items-start px-12")}>
                                       <FuseChipSelect
                                          className="mt-16 w-full sm:w-1/2 sm:mr-8"
                                          id="SelectServicos"
                                          variant="fixed"
                                          value={
                                             !_.isUndefined(form.preatendimento.pedido) && !_.isNull(form.preatendimento.pedido)
                                                ? form.preatendimento.pedido
                                                : []
                                          }
                                          onChange={handleProdutos}
                                          placeholder=""
                                          isClearable={
                                             !_.isUndefined(form.preatendimento.pedido) &&
                                             form.preatendimento.pedido.length !== 0 &&
                                             !_.isNull(form.idagendamento) &&
                                             !canBeSubmitted()
                                          }
                                          isDisabled={
                                             !_.isUndefined(form.preatendimento.pedido) &&
                                             form.preatendimento.pedido.length !== 0 &&
                                             !_.isNull(form.idagendamento) &&
                                             !canBeSubmitted()
                                          }
                                          noOptionsMessage={() => "Sem resultados"}
                                          isMulti
                                          options={getProdutos()}
                                          textFieldProps={{
                                             className: "flex-no-wrap ",
                                             "label": "Serviços *",
                                             InputLabelProps: {
                                                shrink: true,
                                             },
                                             variant: "outlined",
                                             classes: { root: classes.select },
                                          }}
                                          classes={{
                                             valueContainer: "pl-8",
                                             chip: classes.chip,
                                          }}
                                          IndicatorsContainer={{
                                             children: (
                                                <EmpresaProdutoToggleButton
                                                   xappRouteParams={xappRouteParams}
                                                   type="new"
                                                   iconProps="text-24"
                                                   className="h-24"
                                                   callback={() => getBaseFiltro(xappRouteParams)}
                                                   idparent={form.responsaveis.length > 0 ? form.responsaveis[0] : null}
                                                />
                                             )
                                          }}
                                       />
                                       <EmpresaPessoaApp
                                          className="mt-16 w-full sm:w-1/2"
                                          xappRouteParams={xappRouteParams}
                                          selected={
                                             !_.isUndefined(form.preatendimento.idfontepagadora) && !_.isNull(form.preatendimento.idfontepagadora)
                                                ? [
                                                   {
                                                      "id": form.preatendimento.idfontepagadora,
                                                      idpessoaformulario: form.preatendimento.idfontepagadora,
                                                      nome: form.preatendimento.fontepagadoranome,
                                                   },
                                                ]
                                                : []
                                          }
                                          label={"Fonte pagadora"}
                                          id={"LookupNovoAgendamentoFontePagadora"}
                                          onChange={handleLookupFontePagadora}
                                          callback={() => get(form.idagendamento, xappRouteParams)}
                                          required={true}
                                          multiSelect={false}
                                          isLookup={true}
                                          readOnly={
                                             !_.isNull(form.preatendimento.idfontepagadora) && !_.isNull(form.idagendamento) && !canBeSubmitted()
                                          }
                                       />
                                    </div>
                                 )}
                              </React.Fragment>
                           )}
                           {this.state.showContent === 1 && (
                              <div className={"flex w-full"}>
                                 <Anotacao anotacoes={form.anotacoes} handleChangeAnotacoes={handleChangeAnotacoes} />
                              </div>
                           )}
                           {this.state.showContent === 2 && !_.isNull(form.idagendamento) && (
                              <div className={"flex w-full"}>
                                 <EmpresaTarefaApp xappRouteParams={xappRouteParams} idparent={form.idagendamento} tipo={1} />
                              </div>
                           )}
                        </Paper>
                     </div>
                     {this.showSidebar() && (
                        <div className="flex flex-col w-full">
                           {/* OCULTADO TEMPORARIAMENTE - SOLICITAÇÃO MARIO */}
                           {1 === 3 &&
                              !_.isUndefined(form.preatendimento.pedido) &&
                              !_.isNull(form.preatendimento.pedido) &&
                              form.preatendimento.pedido.length > 0 && (
                                 <div className="flex flex-col justify-start">
                                    <Paper className={"block lg:mx-8 my-8 p-12"}>
                                       <Typography className={"text-13 mb-12 whitespace-no-wrap"}>{"Tempo estimado: " + ATempoString}</Typography>
                                       <Typography className={"text-13 mb-12 whitespace-no-wrap"}>
                                          {"Tempo selecionado: " + ASelecionadoString}
                                       </Typography>
                                       <Typography className={"text-13 mb-12 whitespace-no-wrap"}>
                                          {"Valor total: R$ " + AValorTotal.toFixed(2)}
                                       </Typography>
                                    </Paper>
                                 </div>
                              )}
                           {!_.isNull(form.responsaveis) && form.responsaveis.length > 0 && (
                              <div className="flex flex-col justify-start">
                                 <Paper id="PaperHorario" className="w-full lg:mx-8 my-8">
                                    <div className={clsx(classes.toolbar, "w-full flex flex-row items-start justify-start items-center min-h-36")}>
                                       <Typography className="ml-8" color="action">
                                          Horários disponíveis
                                       </Typography>
                                       <div className="flex-1" />
                                    </div>
                                    <div id="ContentDivHorario" className={clsx("block p-12 w-full")}>
                                       <DataHora
                                          handleChange={handleChange}
                                          handleChangeHorarios={handleChangeHorarios}
                                          checkHorarioDisponivel={checkHorarioDisponivel}
                                          handleChangeData={handleChangeData}
                                          form={form}
                                          xappRouteParams={xappRouteParams}
                                          HorarioAgendado={HorarioAgendado}
                                          get={get}
                                          getHorarioAgendadoAll={getHorarioAgendadoAll}
                                          handleResponsaveis={handleResponsaveis}
                                          readOnly={!_.isNull(form.idagendamento) && !canBeSubmitted()}
                                          user={user}
                                       />
                                    </div>
                                 </Paper>
                              </div>
                           )}
                        </div>
                     )}
                  </div>
               </React.Fragment>
            )}
            {form.tabValue === 1 && (
               <React.Fragment>
                  {!_.isUndefined(form.clientesLookup) && !_.isNull(form.clientesLookup) && form.clientesLookup.length > 0 && (
                     <div className={"w-full px-16"}>
                        {form.clientesLookup.map((item, x) => (
                           <Contato
                              key={x}
                              data={item}
                              xappRouteParams={xappRouteParams}
                              agendamento={form}
                              save={save}
                              get={get}
                              STATUS={STATUS}
                              saveAgendamentoPessoa={saveAgendamentoPessoa}
                              TagsPessoa={TagsPessoa}
                              handleChange={handleChange}
                           />
                        ))}
                     </div>
                  )}
               </React.Fragment>
            )}
            {form.tabValue === 2 && (
               <React.Fragment>
                  {!_.isUndefined(form.preatendimento.pedido) && !_.isNull(form.preatendimento.pedido) && form.preatendimento.pedido.length > 0 && (
                     <div className={"w-full px-16"}>
                        {form.preatendimento.pedido.map((item, x) => (
                           <Produto key={x} data={item} xappRouteParams={xappRouteParams} />
                        ))}
                     </div>
                  )}
               </React.Fragment>
            )}
            {form.tabValue === 3 && (
               <React.Fragment>
                  {!_.isUndefined(form.responsaveisLookup) && !_.isNull(form.responsaveisLookup) && form.responsaveisLookup.length > 0 && (
                     <div className={"w-full px-16"}>
                        {form.responsaveisLookup.map((item, x) => (
                           <Responsavel key={x} data={item} xappRouteParams={xappRouteParams} />
                        ))}
                     </div>
                  )}
               </React.Fragment>
            )}
            {!_.isNull(form.idagendamento) && !_.isNull(form.clientes) && form.tabValue === 4 && (
               <React.Fragment>
                  <div className={"flex flex-col items-center justify-center w-full p-16"}>
                     <VincularOportunidade
                        idpessoaformulario={form.clientes[0]}
                        idagendamento={form.idagendamento}
                        xappRouteParams={xappRouteParams}
                     />
                  </div>
               </React.Fragment>
            )}
            {!_.isNull(form.idagendamento) && form.tabValue === 5 && (
               <React.Fragment>
                  <div className={"p-16"}>
                     <ArquivoApp
                        xappRouteParams={xappRouteParams}
                        idfuncionalidade={form.idagendamento}
                        campofuncionalidade={"idagendamento"}
                        tipo={2}
                        showRemover={true}
                     />
                  </div>
               </React.Fragment>
            )}
            {!_.isNull(form.idagendamento) && form.tabValue === 6 && form.clientesLookup?.length === 1 && (
               <TarefaApontamentoPedidoEmAberto
                  xappRouteParams={xappRouteParams}
                  idtarefaprocesso={form.clientesLookup[0].idtarefaprocesso ?? -1}
                  idpessoaformulario={form.clientesLookup[0].idpessoaformulario}
                  automaticUpdate={true}
               />
            )}
         </React.Fragment>
      );
   }
}

export default withStyles(styles, { withTheme: true })(Default);
